import MailHeader from './MailHeader';

export default MailHeader;


// WEBPACK FOOTER //
// /src/components/mailHeader/index.js